export const dateRangeMap = {
  '1': 'SHORT_JANUARY',
  '2': 'SHORT_FEBRUARY',
  '3': 'SHORT_MARCH',
  '4': 'SHORT_APRIL',
  '5': 'SHORT_MAY',
  '6': 'SHORT_JUNE',
  '7': 'SHORT_JULY',
  '8': 'SHORT_AUGUST',
  '9': 'SHORT_SEPTEMBER',
  '10': 'SHORT_OCTOBER',
  '11': 'SHORT_NOVEMBER',
  '12': 'SHORT_DESEMBER',
  '1-2': 'SHORT_JANUARY_AND_SHORT_FEBRUARY',
  '3-4': 'SHORT_MARCH_AND_SHORT_APRIL',
  '5-6': 'SHORT_MAY_AND_SHORT_JUNE',
  '7-8': 'SHORT_JULY_AND_SHORT_AUGUST',
  '9-10': 'SHORT_SEPTEMBER_AND_SHORT_OCTOBER',
  '11-12': 'SHORT_NOVEMBER_AND_SHORT_DESEMBER',
  '1-3': 'FIRST_DECADE',
  '4-6': 'SECOND_DECADE',
  '7-9': 'THIRD_DECADE',
  '10-12': 'FOURTH_DECADE',
  '1-6': 'HALF_YEAR',
  '7-12': 'HALF_YEAR',
};

export const longDateRangeMap = {
  '1': 'JANUARY',
  '2': 'FEBRUARY',
  '3': 'MARCH',
  '4': 'APRIL',
  '5': 'MAY',
  '6': 'JUNE',
  '7': 'JULY',
  '8': 'AUGUST',
  '9': 'SEPTEMBER',
  '10': 'OCTOBER',
  '11': 'NOVEMBER',
  '12': 'DESEMBER',
  '1-2': 'SHORT_JANUARY_AND_SHORT_FEBRUARY',
  '3-4': 'SHORT_MARCH_AND_SHORT_APRIL',
  '5-6': 'SHORT_MAY_AND_SHORT_JUNE',
  '7-8': 'SHORT_JULY_AND_SHORT_AUGUST',
  '9-10': 'SHORT_SEPTEMBER_AND_SHORT_OCTOBER',
  '11-12': 'SHORT_NOVEMBER_AND_SHORT_DESEMBER',
  '1-3': 'FIRST_DECADE',
  '4-6': 'SECOND_DECADE',
  '7-9': 'THIRD_DECADE',
  '10-12': 'FOURTH_DECADE',
  '1-6': 'HALF_YEAR',
  '7-12': 'HALF_YEAR',
};

export default dateRangeMap;
